module.exports = __webpack_public_path__ + "fonts/Merriweather-400-vietnamese14.11350f7.woff2";